/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FeatureResponse } from '../models/FeatureResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class FeaturesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get all available features
     * Returns a dictionary of all available features and their statuses. The status indicates whether the feature is enabled (true) or disabled (false).
     * @returns FeatureResponse
     * @throws ApiError
     */
    public featuresRetrieve(): CancelablePromise<FeatureResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/features/',
        });
    }

}
